<template>
    <div class="global_footer weeducStudentFooter" :class="{ 'dark': this.dark }">
            <div class="logo">
                <img  v-show="!this.dark" src="../../../../../src/assets/logo.png">
                <img  v-show="this.dark" src="../../../../../src/assets/logo_white.png">
               
            </div>
            
            <div class="options">
                <div class="menu item">
                    <ul>
                        <li>
                           Copyright @ 2025 | Todos os direitos reservados
                           <br>
                           <small>Versão: {{ versionPortalWeeduc || 'Desconhecida' }}</small>
                        </li>
                        
                    </ul>
                </div>
            </div>
       </div>
</template>
<script>
import { mapState } from 'vuex';

export default{
    data(){
        return{
            versionPortalWeeduc: '',
        }
    },
    computed:{
        ...mapState(['dark'])
    },
    created(){
        this.versionPortalWeeduc = process.env.VUE_APP_VERSION_PORTAL_WEEDUC;
        console.log('Versão carregada:', this.versionPortalWeeduc);
    }

}
</script>
<style>
@import url('./index.css');
@media only screen and (max-width:600px){

    .global_footer {
        display: block;
        padding: 10px 10px;
    }

}
.global_footer.weeducStudentFooter .item {
    background-color: white !important;
}
/* DARK */
.global_footer.weeducStudentFooter.dark .item {
    background-color:#000000 !important;
    color: white !important;
    padding: 0px 10px !important;
}
</style>